import { render, staticRenderFns } from "./index-shop.vue?vue&type=template&id=970012ac&scoped=true"
import script from "./index-shop.vue?vue&type=script&lang=js"
export * from "./index-shop.vue?vue&type=script&lang=js"
import style0 from "./index-shop.vue?vue&type=style&index=0&id=970012ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970012ac",
  null
  
)

export default component.exports